import React from 'react';
import { motion } from 'framer-motion';
import { Clock3Icon, Globe2Icon, SparklesIcon, ZapIcon } from 'lucide-react';
import { InteriorSlide } from './SlideShell';
import type { SlideProps } from './SlideShell';
const CLIENT_LOGOS = [{
  name: 'Roche',
  src: 'https://cdn.magicpatterns.com/uploads/oKM7AS6Say1ivXnufTeK4Q/Screenshot_2026-08-20_at_21.22.20.png'
}, {
  name: 'GSK',
  src: 'https://cdn.magicpatterns.com/uploads/chs5wo4p9K7rYZAXrMym5b/Screenshot_2026-08-20_at_21.22.24.png'
}, {
  name: 'Boehringer Ingelheim',
  src: 'https://cdn.magicpatterns.com/uploads/d5bawJHBsQSTkegSnvrVuj/Screenshot_2026-08-20_at_21.22.30.png'
}, {
  name: 'LEO Pharma',
  src: 'https://cdn.magicpatterns.com/uploads/pBTS69wAMQQDX9D3vkk2Rb/Screenshot_2026-08-20_at_21.22.35.png'
}, {
  name: 'Novartis',
  src: 'https://cdn.magicpatterns.com/uploads/uUutn2zPPVgFnTSiUdRWCm/Screenshot_2026-08-20_at_21.22.40.png'
}, {
  name: 'CSL',
  src: 'https://cdn.magicpatterns.com/uploads/pJnRcBrTsRx7HkvxQKP8x4/Screenshot_2026-08-20_at_21.23.27.png'
}, {
  name: 'Bayer',
  src: 'https://cdn.magicpatterns.com/uploads/gfWrjGPFiTnQ1dPmioRizg/Screenshot_2026-08-20_at_21.23.50.png'
}, {
  name: 'AbbVie',
  src: 'https://cdn.magicpatterns.com/uploads/68jEZZhKCb8PVjShWy7xh7/Screenshot_2026-08-20_at_21.24.11.png'
}];
export function SlideEnterpriseScale({}: SlideProps) {
  return <InteriorSlide data-id="element-86" data-mp="1oglptublo31m">
      <div className="grid min-h-0 flex-1 grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-87" data-mp="1og24e3mqqwiu">
        <motion.section initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55
      }} className="flex min-h-0 flex-col justify-between lg:col-span-7" data-id="element-88" data-mp="22beaf76ck9f2">
          <div data-id="element-89" data-mp="277uzq4pa8ttq">
            <div className="mb-7 flex items-center gap-3" data-id="element-90" data-mp="279ftvt7oqar2">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[var(--brand)] text-white shadow-lg" data-id="element-91" data-mp="htge3t9k9n2g">
                <Clock3Icon className="h-5 w-5" data-id="element-92" data-mp="cv549ij9nck8" />
              </span>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-93" data-mp="12iio757t4v7q">
                Meet Snakker
              </p>
            </div>

            <h2 className="max-w-[58rem] font-serif text-[clamp(3.2rem,6vw,6.4rem)] font-semibold leading-[0.92] tracking-[-0.045em] text-[var(--fg)]" data-id="element-94" data-mp="16kmc4tbnxs9w">
              HCPs don’t lack content.
              <span className="block text-[var(--brand)]" data-id="element-95" data-mp="1gj367z5wen06">They lack time.</span>
            </h2>

            <div className="mt-8 max-w-[48rem] border-l-4 border-[var(--accent)] pl-6" data-id="element-96" data-mp="1lglk83yrvsf1">
              <p className="text-[clamp(1.15rem,1.9vw,1.65rem)] font-semibold leading-snug text-[var(--fg)]" data-id="element-97" data-mp="1phx0vjzo53b3">
                HCPs no longer have time for a three-course meal. They need short, sharp and satisfying Snaks™.
              </p>
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.35,
          duration: 0.5
        }} className="mt-8 flex items-center gap-4 rounded-3xl bg-[var(--brand)] px-6 py-5 text-white shadow-xl" data-id="element-98" data-mp="2484hdu648c95">
            <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl bg-white/10" data-id="element-99" data-mp="3oq6oty785318">
              <ZapIcon className="h-6 w-6 text-[#F8D34A]" data-id="element-100" data-mp="3jqalm16cpfmq" />
            </span>
            <div data-id="element-101" data-mp="3erqyhxg0txss">
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-[var(--brand-lighter)]" data-id="element-102" data-mp="3es90lapd768m">
                The simple answer
              </p>
              <p className="mt-1 font-serif text-[clamp(1.8rem,3vw,3rem)] font-semibold leading-none" data-id="element-103" data-mp="gc6gj335mjua">
                Snakker creates Snaks™.
              </p>
            </div>
          </motion.div>
        </motion.section>

        <motion.aside initial={{
        opacity: 0,
        x: 24
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.15,
        duration: 0.6
      }} className="flex min-h-0 flex-col gap-4 lg:col-span-5" data-id="element-104" data-mp="1l7b20xm8bex">
          <div className="rounded-3xl border border-[var(--brand)]/10 bg-white p-6 shadow-sm" data-id="element-105" data-mp="u8tpk48dt0gk">
            <div className="flex items-center gap-3" data-id="element-106" data-mp="erllba19zs2a">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[var(--brand-lighter)] text-[var(--brand)]" data-id="element-107" data-mp="eu7tnbvzqblk">
                <SparklesIcon className="h-5 w-5" data-id="element-108" data-mp="4ugzxcf980mj" />
              </span>
              <h3 className="font-serif text-2xl font-semibold text-[var(--fg)]" data-id="element-109" data-mp="9ssa5o9god5a">AI-native by design</h3>
            </div>
            <p className="mt-4 text-[clamp(0.9rem,1.2vw,1.05rem)] leading-relaxed text-[var(--muted)]" data-id="element-110" data-mp="xhtd4vziyw36">
              Snakker is an AI-native creative agency specialized in short, impactful life-science marketing. We create, execute, run and continuously optimize campaigns across brands, countries and channels—at radically different economics.
            </p>
          </div>

          <div className="flex-1 rounded-3xl border border-[var(--brand)]/10 bg-[var(--surface)] p-5" data-id="element-111" data-mp="1gh7bdq4aeszh">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[var(--brand)]" data-id="element-112" data-mp="1l7nmh3kmy2io">Trusted by</p>
            <div className="mt-3 grid grid-cols-4 gap-2" data-id="element-113" data-mp="35y2q34u3aeja">
              {CLIENT_LOGOS.map(client => <div key={client.name} className="flex h-[clamp(3.1rem,5.4vw,4.75rem)] items-center justify-center rounded-xl border border-[var(--brand)]/10 bg-white p-2 shadow-sm" data-id="element-114" data-mp="30zrk556x0o6c">
                  <img src={client.src} alt={client.name} className="h-full w-full object-contain" data-id="element-115" data-mp="3apkszyfoap6w" />
                </div>)}
            </div>
            <p className="mt-3 text-right text-xs font-semibold italic text-[var(--muted)]" data-id="element-116" data-mp="2i2q9b3qojtuh">
              ...and many more
            </p>
          </div>

          <div className="rounded-3xl bg-[var(--accent)] p-6 text-white shadow-lg" data-id="element-117" data-mp="2rxs2cao2tg2c">
            <div className="flex items-center gap-4" data-id="element-118" data-mp="b8wb0pwwl720">
              <Globe2Icon className="h-8 w-8 flex-shrink-0" data-id="element-119" data-mp="bbsawjsba5t3" />
              <div data-id="element-120" data-mp="77svy5mojf1u">
                <p className="font-serif text-4xl font-semibold leading-none" data-id="element-121" data-mp="7af3i59kluk2">25+ countries</p>
                <p className="mt-2 text-sm font-semibold text-white/80" data-id="element-122" data-mp="302kmumdeosw3">Campaigns running from Finland to China.</p>
              </div>
            </div>
          </div>
        </motion.aside>
      </div>
    </InteriorSlide>;
}